import React from 'react'
import ComponentPageDom from 'elements/ComponentPageDom'
import i18n from 'lib/i18n'

const _ = i18n('b2b')

export default class B2b extends React.Component {
	render() {
		const {noHeader} = this.props
		return (
			<ComponentPageDom
				{...{
					noHeader,
					title: _('title'),
					subtitle: _('subtitle'),
				}}
			>
				{_('selectInsuranceCompany')}
			</ComponentPageDom>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2b/index.jsx